module.exports = __webpack_public_path__ + "static/media/amazon.6dc37ea1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/search-step/amazon.png
// module id = 622
// module chunks = 0